import { Tab } from "@mui/material";
import styled from "styled-components";

export const ScenarioBuilderStyledTab = styled(Tab)`
  padding: 0 20px !important;
  background: #162239 !important;
  color: #E2E2E2 !important;
  box-shadow: inset 0px 3px 6px #000000;
  border: 1px solid #F5F5F569 !important;
`